import React, { useEffect } from 'react'
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import { Box } from '@mui/material'
import colors from '../../constants/colors'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { ITextEditor } from './types'

const wrapperStyle = {
  border: `1px solid ${colors.TAG_LINES_GRAY}`,
  borderRadius: '1rem',
}

const toolbarStyle = {
  border: 'none',
  borderRadius: '0',
  backgroundColor: colors.TAG_GRAY_FILL,
  borderBottom: `1px solid ${colors.TAG_LINES_GRAY}`,
}

const toolbarOptions = {
  options: ['inline', 'link', 'list'],
  inline: { options: ['bold', 'italic'] },
  list: {
    inDropdown: false,
  },
}

const TextEditor: React.FC<ITextEditor> = ({ setText, text = false }) => {
  const [editorState, setEditorState] = React.useState(EditorState.createEmpty())

  useEffect(() => {
    const blocks = convertToRaw(editorState.getCurrentContent()).blocks
    const value = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n')
    if (value.length > 1) setText(value)
  }, [editorState])

  useEffect(() => {
    if (text) {
      const contentState = convertFromRaw({
        entityMap: {},
        blocks: [
          {
            data: {},
            inlineStyleRanges: [],
            depth: 0,
            text: text,
            type: 'unstyled',
            key: 'foo',
            entityRanges: [],
          },
        ],
      })
      setEditorState(EditorState.createWithContent(contentState))
    }
  }, [text])

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Editor
        wrapperClassName={text.length > 1 ? 't-disabled' : ''}
        editorState={editorState}
        onEditorStateChange={setEditorState}
        toolbar={toolbarOptions}
        wrapperStyle={wrapperStyle}
        toolbarStyle={toolbarStyle}
      />
    </Box>
  )
}

export default TextEditor
